
export default function FlashResultsCardHeader({headerTitle, children}) {
    // Used in Results Cards to display card header information
    // made of text and additional element (children)

    // BUILD
    return (
        <div className="w-full flex justify-between px-[12px] pt-[12px]">
            <span className="text-greyLight9 text-[16px] font-medium">
                {headerTitle}
            </span>
            {children}
        </div>
    );
}